// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
  AnnotationCreateData,
  AnnotationCreateErrors,
  AnnotationCreateResponses,
  AnnotationDeleteData,
  AnnotationDeleteErrors,
  AnnotationDeleteResponses,
  AnnotationGetData,
  AnnotationGetErrors,
  AnnotationGetResponses,
  AnnotationListData,
  AnnotationListErrors,
  AnnotationListResponses,
  AnnotationUpdateData,
  AnnotationUpdateErrors,
  AnnotationUpdateResponses,
  DocumentCreateData,
  DocumentCreateErrors,
  DocumentCreateResponses,
  DocumentDeleteData,
  DocumentDeleteErrors,
  DocumentDeleteResponses,
  DocumentGetData,
  DocumentGetErrors,
  DocumentGetResponses,
  DocumentGetSignedUrlData,
  DocumentGetSignedUrlErrors,
  DocumentGetSignedUrlResponses,
  DocumentGetUploadSignedUrlData,
  DocumentGetUploadSignedUrlErrors,
  DocumentGetUploadSignedUrlResponses,
  DocumentListData,
  DocumentListErrors,
  DocumentListResponses,
  DocumentUpdateData,
  DocumentUpdateErrors,
  DocumentUpdateResponses,
  InternalNoteCreateData,
  InternalNoteCreateErrors,
  InternalNoteCreateResponses,
  InternalNoteDeleteData,
  InternalNoteDeleteErrors,
  InternalNoteDeleteResponses,
  InternalNoteGetData,
  InternalNoteGetErrors,
  InternalNoteGetResponses,
  InternalNoteListData,
  InternalNoteListErrors,
  InternalNoteListResponses,
  InternalNoteUpdateData,
  InternalNoteUpdateErrors,
  InternalNoteUpdateResponses,
  ParticipantAddData,
  ParticipantAddErrors,
  ParticipantAddResponses,
  ParticipantListData,
  ParticipantListErrors,
  ParticipantListResponses,
  ParticipantRemoveData,
  ParticipantRemoveErrors,
  ParticipantRemoveResponses,
  ParticipantRoundStatusCreateData,
  ParticipantRoundStatusCreateErrors,
  ParticipantRoundStatusCreateResponses,
  ParticipantRoundStatusDeleteData,
  ParticipantRoundStatusDeleteErrors,
  ParticipantRoundStatusDeleteResponses,
  ParticipantRoundStatusListData,
  ParticipantRoundStatusListErrors,
  ParticipantRoundStatusListResponses,
  ParticipantRoundStatusUpdateData,
  ParticipantRoundStatusUpdateErrors,
  ParticipantRoundStatusUpdateResponses,
  ProofingRoundCreateData,
  ProofingRoundCreateErrors,
  ProofingRoundCreateResponses,
  ProofingRoundDeleteData,
  ProofingRoundDeleteErrors,
  ProofingRoundDeleteResponses,
  ProofingRoundGetData,
  ProofingRoundGetErrors,
  ProofingRoundGetResponses,
  ProofingRoundListData,
  ProofingRoundListErrors,
  ProofingRoundListResponses,
  ProofingRoundUpdateData,
  ProofingRoundUpdateErrors,
  ProofingRoundUpdateResponses,
  ProofingTitleCreateData,
  ProofingTitleCreateErrors,
  ProofingTitleCreateResponses,
  ProofingTitleDeleteData,
  ProofingTitleDeleteErrors,
  ProofingTitleDeleteResponses,
  ProofingTitleGetData,
  ProofingTitleGetErrors,
  ProofingTitleGetResponses,
  ProofingTitleListData,
  ProofingTitleListErrors,
  ProofingTitleListMineData,
  ProofingTitleListMineErrors,
  ProofingTitleListMineResponses,
  ProofingTitleListResponses,
  ProofingTitleUpdateData,
  ProofingTitleUpdateErrors,
  ProofingTitleUpdateResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * List proofing titles
 */
export const proofingTitleList = <ThrowOnError extends boolean = true>(
  options?: Options<ProofingTitleListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ProofingTitleListResponses,
    ProofingTitleListErrors,
    ThrowOnError
  >({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/titles",
    ...options,
  });

/**
 * Create a proofing title
 */
export const proofingTitleCreate = <ThrowOnError extends boolean = true>(
  options?: Options<ProofingTitleCreateData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    ProofingTitleCreateResponses,
    ProofingTitleCreateErrors,
    ThrowOnError
  >({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/titles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * List titles created by or assigned to the caller
 */
export const proofingTitleListMine = <ThrowOnError extends boolean = true>(
  options?: Options<ProofingTitleListMineData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ProofingTitleListMineResponses,
    ProofingTitleListMineErrors,
    ThrowOnError
  >({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/titles/my",
    ...options,
  });

/**
 * Soft delete a proofing title
 */
export const proofingTitleDelete = <ThrowOnError extends boolean = true>(
  options: Options<ProofingTitleDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    ProofingTitleDeleteResponses,
    ProofingTitleDeleteErrors,
    ThrowOnError
  >({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/titles/{titleId}",
    ...options,
  });

/**
 * Get comprehensive proofing title details
 */
export const proofingTitleGet = <ThrowOnError extends boolean = true>(
  options: Options<ProofingTitleGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<ProofingTitleGetResponses, ProofingTitleGetErrors, ThrowOnError>({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/titles/{titleId}",
    ...options,
  });

/**
 * Update a proofing title
 */
export const proofingTitleUpdate = <ThrowOnError extends boolean = true>(
  options: Options<ProofingTitleUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ProofingTitleUpdateResponses,
    ProofingTitleUpdateErrors,
    ThrowOnError
  >({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/titles/{titleId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List rounds for a title with enriched historical data
 */
export const proofingRoundList = <ThrowOnError extends boolean = true>(
  options: Options<ProofingRoundListData, ThrowOnError>,
) =>
  (options.client ?? client).get<ProofingRoundListResponses, ProofingRoundListErrors, ThrowOnError>(
    {
      security: [
        {
          in: "cookie",
          name: "lx-auth",
          type: "apiKey",
        },
      ],
      url: "/api/proofing/titles/{titleId}/rounds",
      ...options,
    },
  );

/**
 * Create a round under a title
 */
export const proofingRoundCreate = <ThrowOnError extends boolean = true>(
  options: Options<ProofingRoundCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ProofingRoundCreateResponses,
    ProofingRoundCreateErrors,
    ThrowOnError
  >({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/titles/{titleId}/rounds",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Soft delete a round
 */
export const proofingRoundDelete = <ThrowOnError extends boolean = true>(
  options: Options<ProofingRoundDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    ProofingRoundDeleteResponses,
    ProofingRoundDeleteErrors,
    ThrowOnError
  >({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/titles/{titleId}/rounds/{roundId}",
    ...options,
  });

/**
 * Get a round
 */
export const proofingRoundGet = <ThrowOnError extends boolean = true>(
  options: Options<ProofingRoundGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<ProofingRoundGetResponses, ProofingRoundGetErrors, ThrowOnError>({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/titles/{titleId}/rounds/{roundId}",
    ...options,
  });

/**
 * Update a round
 */
export const proofingRoundUpdate = <ThrowOnError extends boolean = true>(
  options: Options<ProofingRoundUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ProofingRoundUpdateResponses,
    ProofingRoundUpdateErrors,
    ThrowOnError
  >({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/titles/{titleId}/rounds/{roundId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List documents for a round
 */
export const documentList = <ThrowOnError extends boolean = true>(
  options: Options<DocumentListData, ThrowOnError>,
) =>
  (options.client ?? client).get<DocumentListResponses, DocumentListErrors, ThrowOnError>({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/rounds/{roundId}/documents",
    ...options,
  });

/**
 * Create a document for a round
 */
export const documentCreate = <ThrowOnError extends boolean = true>(
  options: Options<DocumentCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<DocumentCreateResponses, DocumentCreateErrors, ThrowOnError>({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/rounds/{roundId}/documents",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Soft delete a document
 */
export const documentDelete = <ThrowOnError extends boolean = true>(
  options: Options<DocumentDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DocumentDeleteResponses, DocumentDeleteErrors, ThrowOnError>({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/rounds/{roundId}/documents/{documentId}",
    ...options,
  });

/**
 * Get a document
 */
export const documentGet = <ThrowOnError extends boolean = true>(
  options: Options<DocumentGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<DocumentGetResponses, DocumentGetErrors, ThrowOnError>({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/rounds/{roundId}/documents/{documentId}",
    ...options,
  });

/**
 * Update a document
 */
export const documentUpdate = <ThrowOnError extends boolean = true>(
  options: Options<DocumentUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<DocumentUpdateResponses, DocumentUpdateErrors, ThrowOnError>({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/rounds/{roundId}/documents/{documentId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Generate a signed download URL for a document
 */
export const documentGetSignedUrl = <ThrowOnError extends boolean = true>(
  options: Options<DocumentGetSignedUrlData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    DocumentGetSignedUrlResponses,
    DocumentGetSignedUrlErrors,
    ThrowOnError
  >({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/documents/{documentId}/signed-url",
    ...options,
  });

/**
 * Generate a signed upload URL for a path
 */
export const documentGetUploadSignedUrl = <ThrowOnError extends boolean = true>(
  options: Options<DocumentGetUploadSignedUrlData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    DocumentGetUploadSignedUrlResponses,
    DocumentGetUploadSignedUrlErrors,
    ThrowOnError
  >({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/documents/signed-url",
    ...options,
  });

/**
 * List annotations for a document
 */
export const annotationList = <ThrowOnError extends boolean = true>(
  options: Options<AnnotationListData, ThrowOnError>,
) =>
  (options.client ?? client).get<AnnotationListResponses, AnnotationListErrors, ThrowOnError>({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/documents/{documentId}/annotations",
    ...options,
  });

/**
 * Create an annotation
 */
export const annotationCreate = <ThrowOnError extends boolean = true>(
  options: Options<AnnotationCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<AnnotationCreateResponses, AnnotationCreateErrors, ThrowOnError>({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/documents/{documentId}/annotations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Soft delete an annotation
 */
export const annotationDelete = <ThrowOnError extends boolean = true>(
  options: Options<AnnotationDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    AnnotationDeleteResponses,
    AnnotationDeleteErrors,
    ThrowOnError
  >({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/documents/{documentId}/annotations/{annotationId}",
    ...options,
  });

/**
 * Get an annotation
 */
export const annotationGet = <ThrowOnError extends boolean = true>(
  options: Options<AnnotationGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<AnnotationGetResponses, AnnotationGetErrors, ThrowOnError>({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/documents/{documentId}/annotations/{annotationId}",
    ...options,
  });

/**
 * Update an annotation
 */
export const annotationUpdate = <ThrowOnError extends boolean = true>(
  options: Options<AnnotationUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<AnnotationUpdateResponses, AnnotationUpdateErrors, ThrowOnError>(
    {
      security: [
        {
          in: "cookie",
          name: "lx-auth",
          type: "apiKey",
        },
      ],
      url: "/api/proofing/documents/{documentId}/annotations/{annotationId}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    },
  );

/**
 * List participants for a title
 */
export const participantList = <ThrowOnError extends boolean = true>(
  options: Options<ParticipantListData, ThrowOnError>,
) =>
  (options.client ?? client).get<ParticipantListResponses, ParticipantListErrors, ThrowOnError>({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/titles/{titleId}/participants",
    ...options,
  });

/**
 * Add a participant to a title
 */
export const participantAdd = <ThrowOnError extends boolean = true>(
  options: Options<ParticipantAddData, ThrowOnError>,
) =>
  (options.client ?? client).post<ParticipantAddResponses, ParticipantAddErrors, ThrowOnError>({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/titles/{titleId}/participants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove a participant from a title
 */
export const participantRemove = <ThrowOnError extends boolean = true>(
  options: Options<ParticipantRemoveData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    ParticipantRemoveResponses,
    ParticipantRemoveErrors,
    ThrowOnError
  >({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/titles/{titleId}/participants/{userId}",
    ...options,
  });

/**
 * Soft delete participant round status
 */
export const participantRoundStatusDelete = <ThrowOnError extends boolean = true>(
  options: Options<ParticipantRoundStatusDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    ParticipantRoundStatusDeleteResponses,
    ParticipantRoundStatusDeleteErrors,
    ThrowOnError
  >({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/rounds/{roundId}/participants/{userId}/status",
    ...options,
  });

/**
 * Update participant round status
 */
export const participantRoundStatusUpdate = <ThrowOnError extends boolean = true>(
  options: Options<ParticipantRoundStatusUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ParticipantRoundStatusUpdateResponses,
    ParticipantRoundStatusUpdateErrors,
    ThrowOnError
  >({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/rounds/{roundId}/participants/{userId}/status",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create participant round status (invite participant to round)
 */
export const participantRoundStatusCreate = <ThrowOnError extends boolean = true>(
  options: Options<ParticipantRoundStatusCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ParticipantRoundStatusCreateResponses,
    ParticipantRoundStatusCreateErrors,
    ThrowOnError
  >({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/rounds/{roundId}/participants/{userId}/status",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List participant statuses for a round
 */
export const participantRoundStatusList = <ThrowOnError extends boolean = true>(
  options: Options<ParticipantRoundStatusListData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ParticipantRoundStatusListResponses,
    ParticipantRoundStatusListErrors,
    ThrowOnError
  >({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/rounds/{roundId}/participants",
    ...options,
  });

/**
 * List internal notes for a title
 */
export const internalNoteList = <ThrowOnError extends boolean = true>(
  options: Options<InternalNoteListData, ThrowOnError>,
) =>
  (options.client ?? client).get<InternalNoteListResponses, InternalNoteListErrors, ThrowOnError>({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/titles/{titleId}/notes",
    ...options,
  });

/**
 * Create an internal note
 */
export const internalNoteCreate = <ThrowOnError extends boolean = true>(
  options: Options<InternalNoteCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    InternalNoteCreateResponses,
    InternalNoteCreateErrors,
    ThrowOnError
  >({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/titles/{titleId}/notes",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Soft delete an internal note
 */
export const internalNoteDelete = <ThrowOnError extends boolean = true>(
  options: Options<InternalNoteDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    InternalNoteDeleteResponses,
    InternalNoteDeleteErrors,
    ThrowOnError
  >({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/titles/{titleId}/notes/{noteId}",
    ...options,
  });

/**
 * Get an internal note
 */
export const internalNoteGet = <ThrowOnError extends boolean = true>(
  options: Options<InternalNoteGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<InternalNoteGetResponses, InternalNoteGetErrors, ThrowOnError>({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/titles/{titleId}/notes/{noteId}",
    ...options,
  });

/**
 * Update an internal note
 */
export const internalNoteUpdate = <ThrowOnError extends boolean = true>(
  options: Options<InternalNoteUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    InternalNoteUpdateResponses,
    InternalNoteUpdateErrors,
    ThrowOnError
  >({
    security: [
      {
        in: "cookie",
        name: "lx-auth",
        type: "apiKey",
      },
    ],
    url: "/api/proofing/titles/{titleId}/notes/{noteId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
